import { parseLocalDate } from "../../../utils/dateUtils";

const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAY_ABBR = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const dateOf = (session) => {
  const raw = session.sessionDate || session.date;
  const d = raw ? parseLocalDate(raw) : null;
  return d && !Number.isNaN(d.getTime()) ? d : null;
};
const startOfDay = (d) => { const c = new Date(d); c.setHours(0, 0, 0, 0); return c; };

export function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}

/** { weekday: "Tue", month: "Sep", day: 22 } for a session, or null when it has no valid date. */
export function sessionDateParts(session) {
  const d = dateOf(session);
  return d ? { weekday: DAY_ABBR[d.getDay()], month: MONTH_ABBR[d.getMonth()], day: d.getDate() } : null;
}

/** live = published; held = dated before today; otherwise upcoming (including today and undated). */
export function sessionState(session, now = new Date()) {
  if (session.enabled === true) return "live";
  const d = dateOf(session);
  return d && startOfDay(d) < startOfDay(now) ? "held" : "upcoming";
}

export function courseStatus(course, sessions) {
  if (course.lifecycleStatus === "COMPLETED" || course.status === "COMPLETED" || course.status === "Completed") return "complete";
  if (sessions.some((s) => s.enabled === true)) return "live";
  return sessions.length === 0 && !course.date ? "draft" : "upcoming";
}

export function sortedSessions(sessions) {
  const time = (s) => dateOf(s)?.getTime() ?? Infinity;
  return [...sessions].sort((a, b) => time(a) - time(b) || Number(a.id) - Number(b.id));
}

/** Held count, total, the next unpublished session on or after today, and total check-ins across held sessions. */
export function courseProgress(sessions, now = new Date()) {
  const ordered = sortedSessions(sessions);
  const held = ordered.filter((s) => sessionState(s, now) === "held");
  const next = ordered.find((s) => sessionState(s, now) === "upcoming") || null;
  return {
    done: held.length,
    total: sessions.length,
    next,
    attended: held.reduce((sum, s) => sum + (s.checkedIn ?? 0), 0),
  };
}

export function countCourses(courses, sessionsMap) {
  const counts = { all: courses.length, live: 0, upcoming: 0, complete: 0, draft: 0 };
  courses.forEach((c) => { counts[courseStatus(c, sessionsMap[c.id] || [])] += 1; });
  return counts;
}

export function filterCourses(courses, sessionsMap, { status = "all", query = "" } = {}) {
  const q = query.trim().toLowerCase();
  return courses.filter((c) => {
    const text = [c.title, c.name, c.courseNumber, c.code, c.category, c.location].filter(Boolean).join(" ").toLowerCase();
    return (!q || text.includes(q)) && (status === "all" || courseStatus(c, sessionsMap[c.id] || []) === status);
  });
}
